module.exports = __webpack_public_path__ + "static/img/3327_phase_function_Paper_PointsHejduk_Prediction.409a624.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3327_phase_function_Paper_PointsHejduk_Prediction.png
// module id = EYsw
// module chunks = 0